import { render } from "./MypageFavorites.vue?vue&type=template&id=56e6dc00&scoped=true&ts=true"
import script from "./MypageFavorites.vue?vue&type=script&lang=ts"
export * from "./MypageFavorites.vue?vue&type=script&lang=ts"

import "./MypageFavorites.vue?vue&type=style&index=0&id=56e6dc00&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e6dc00"]])

export default __exports__